
import { useState } from 'react';

const ProductInfo = () => {
  const [quantity, setQuantity] = useState(1);

  const handleQuantityChange = (delta: number) => {
    setQuantity(Math.max(1, quantity + delta));
  };

  return (
    <div className="w-full">
      <div className="mb-4">
        <span className="inline-block px-3 py-1 bg-teal-100 text-teal-700 text-sm font-medium rounded-full">
          주변기기
        </span>
      </div>

      <h1 className="text-3xl font-bold text-gray-900 mb-4">
        로지텍 G PRO X 기계식 게이밍 키보드
      </h1>

      <div className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-2xl p-6 mb-6">
        <div className="flex items-center justify-center">
          <span className="text-4xl font-bold text-teal-600">구매협의</span>
        </div>
        <p className="text-center text-sm text-gray-600 mt-3">
          견적 문의를 통해 최적의 가격을 안내해 드립니다
        </p>
      </div>

      <div className="border-t border-b border-gray-200 py-6 mb-6">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <p className="text-sm text-gray-500 mb-1">스위치 타입</p>
            <p className="text-base font-semibold text-gray-900">GX Blue Clicky</p>
          </div>
          <div>
            <p className="text-sm text-gray-500 mb-1">연결 방식</p>
            <p className="text-base font-semibold text-gray-900">유선 USB</p>
          </div>
          <div>
            <p className="text-sm text-gray-500 mb-1">백라이트</p>
            <p className="text-base font-semibold text-gray-900">RGB 라이트싱크</p>
          </div>
          <div>
            <p className="text-sm text-gray-500 mb-1">키 레이아웃</p>
            <p className="text-base font-semibold text-gray-900">텐키리스 (87키)</p>
          </div>
        </div>
      </div>

      <div className="space-y-4 mb-6">
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <i className="ri-truck-line text-teal-600 text-lg w-5 h-5 flex items-center justify-center"></i>
          <span>배송비 3,000원 (50,000원 이상 무료배송)</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <i className="ri-shield-check-line text-teal-600 text-lg w-5 h-5 flex items-center justify-center"></i>
          <span>2년 제조사 보증</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <i className="ri-refresh-line text-teal-600 text-lg w-5 h-5 flex items-center justify-center"></i>
          <span>7일 이내 단순 변심 반품 가능 (미개봉 시)</span>
        </div>
      </div>

      <div className="flex items-center gap-4 mb-6">
        <span className="text-sm font-medium text-gray-700 whitespace-nowrap">수량</span>
        <div className="flex items-center border border-gray-300 rounded-lg">
          <button
            onClick={() => handleQuantityChange(-1)}
            className="w-10 h-10 flex items-center justify-center text-gray-600 hover:bg-gray-100 transition-colors cursor-pointer"
          >
            <i className="ri-subtract-line"></i>
          </button>
          <input
            type="number"
            value={quantity}
            onChange={(e) => setQuantity(Math.max(1, parseInt(e.target.value) || 1))}
            className="w-16 h-10 text-center border-x border-gray-300 text-sm"
          />
          <button
            onClick={() => handleQuantityChange(1)}
            className="w-10 h-10 flex items-center justify-center text-gray-600 hover:bg-gray-100 transition-colors cursor-pointer"
          >
            <i className="ri-add-line"></i>
          </button>
        </div>
      </div>

      <div className="flex gap-3">
        <button className="flex-1 px-6 py-4 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer">
          구매하기
        </button>
        <button className="flex-1 px-6 py-4 bg-gray-900 text-white font-semibold rounded-lg hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer">
          견적 문의
        </button>
      </div>

      <div className="mt-6 p-4 bg-amber-50 border border-amber-200 rounded-lg">
        <h3 className="text-sm font-bold text-amber-900 mb-2 flex items-center gap-2">
          <i className="ri-shopping-cart-line w-4 h-4 flex items-center justify-center"></i>
          기업 대량 구매 안내
        </h3>
        <p className="text-sm text-amber-800 mb-2">
          10개 이상 구매 시 특별 할인 혜택을 제공해드립니다.
        </p>
        <p className="text-sm text-amber-900 font-medium">
          문의: 02-702-0999 | ecov2025@naver.com
        </p>
      </div>
    </div>
  );
};

export default ProductInfo;